import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';


export class UsersignatureApi extends SystemBaseApi {

    public get ControllerName(): any {
        return 'usersignature'
    }

    public getDataById(userId) {
        return this.send({ userId: userId }, "getDataById", Methods.GET)
    }
    public getDataByIdV2(userId) {
        return this.send({ userId: userId }, "getDataByIdV2", Methods.GET)
    }
    public getDataListById(userId) {
        return this.send({ userId: userId }, "getDataListById", Methods.GET)
    }
    
    public getUsersignatureList() {
        return this.send({}, "getUsersignatureList", Methods.GET)
    }

    public getDataByUserIds(userIds,signType:any) {
        return this.send({ userIds: userIds,signType:signType }, "getDataByUserIds", Methods.GET)
    }

    /**
     * 保存签字Base64
     * @param params
     */
    public saveSign(params) {
        return this.send(params, "saveSign", Methods.POST)
    }

    public insert(params) {
        return this.send(params, "insert", Methods.POST)
    }



}
